// Static reference content for the Care Comply CDA Journey.
// Sources: Council for Professional Recognition (cdacouncil.org), Texas AEYC.

export const PAYMENT_URL = "https://buy.stripe.com/bJeeVdgMk5238F3dvJgYU01";
export const CDA_COVER_SHEETS_URL = "https://drive.google.com/file/d/1JmIx3HGP-Z_5fVfQLVKP9lRnlGnQJHCB/view?usp=sharing";

// Recommended class catalogs & early-childhood resources
export const RESOURCE_LINKS = [
  { name: "Texas A&M AgriLife Learn — Child Care courses", note: "Paid & free CDA classes for your binder", url: "https://agrilifelearn.tamu.edu/s/category/browse-by-category/child-care/0ZG4x00000095lOGAQ" },
  { name: "Texas AEYC", note: "Early childhood association & resources", url: "https://texasaeyc.org/about-us/" },
];
export const GOOGLE_REVIEW_URL = ""; // To be provided by owner; button falls back gracefully.

export const LOGO_URL = "https://static.prod-images.emergentagent.com/jobs/574f4e75-09df-4f34-882a-f8d9217d04a9/images/46c9e7972dda735d4e4840a4e1deb95280627e7170abf63f81c842ce4858d259.png";
export const BADGE_URL = "https://static.prod-images.emergentagent.com/jobs/574f4e75-09df-4f34-882a-f8d9217d04a9/images/c33bc5e57c58c52d1f8bc4ef2524e545b208d8b9494b322327a4224962d7d6b2.png";
export const JAZMIN_AVATAR_URL = "https://static.prod-images.emergentagent.com/jobs/574f4e75-09df-4f34-882a-f8d9217d04a9/images/ab6f9432cd31f80b30b59beb74dd065aafe5ba9bbde104c3af58c527c40f5f20.png";

export const PRICING = {
  monthlyPrice: "$19.99",
  monthlyLabel: "per month",
  promoCode: "CDACAREER",
  note: "Most candidates finish within 6 months. Cancel anytime — this app exists to get you credentialed, not to keep you paying.",
};

export const CDA_SETTINGS = [
  { id: "infant_toddler", name: "Infant-Toddler", ages: "Birth to 36 months", desc: "You work primarily with babies and toddlers." },
  { id: "preschool", name: "Preschool", ages: "3 to 5 years", desc: "You work primarily with preschool-age children." },
  { id: "family_child_care", name: "Family Child Care", ages: "Birth to 5 years", desc: "You run or work in a home-based child care." },
  { id: "home_visitor", name: "Home Visitor", ages: "Birth to 5 years", desc: "You support families through home visits." },
];

// Online CDA coursework providers (the 120 formal-education hours)
export const CDA_PROGRAMS = [
  { name: "TickTock Training", url: "https://www.ticktocktraining.org/cda", note: "Self-paced 120-hour CDA coursework", badge: "Most affordable" },
  { name: "NICCM Fast Track", url: "https://niccm.com/General/cda-fast-track.html", note: "Accelerated CDA Fast Track" },
  { name: "Texas A&M AgriLife Learn", url: "https://agrilifelearn.tamu.edu/s/category/browse-by-category/child-care/0ZG4x00000095lOGAQ", note: "Online, self-paced child care & CDA course bundles" },
  { name: "At The Heart", url: "https://www.attheheart.org/pages/earn-your-cda%C2%AE-online-with-at-the-heart", note: "Earn your CDA online" },
  { name: "PACE at UTSA", url: "https://careertraining.pace.utsa.edu/training-programs/child-development-associate-center-based/", note: "Center-Based CDA — San Antonio" },
  { name: "Alamo Colleges (Self-Paced Online)", url: "https://selfpacedonline.alamo.edu/training-programs/child-development-associate-center-based/", note: "Center-Based CDA — self-paced online" },
  { name: "Restore Education", url: "https://restoreeducation.org/programs/career-readiness-and-training/", note: "CDA program — San Antonio" },
  { name: "Pre-K 4 SA", url: "https://prek4sa.com/why-pre-k-4-sa/educators/", note: "Professional Learning 120-hr CDA — San Antonio" },
];

// Free CDA classes option (listed separately)
export const FAMILY_SERVICE_CDA = {
  name: "Family Service Association of San Antonio",
  url: "https://family-service.org/cda/",
  address: "702 San Pedro Ave., San Antonio, TX 78212",
  phone: "(210) 431-4422",
};

// The 8 CDA subject areas (need at least 10 hours in EACH = part of the 120)
export const SUBJECT_AREAS = [
  "Planning a safe & healthy learning environment",
  "Advancing children's physical & intellectual development",
  "Supporting social & emotional development & positive guidance",
  "Building productive relationships with families",
  "Managing an effective program operation",
  "Maintaining a commitment to professionalism",
  "Observing & recording children's behavior",
  "Principles of child growth & development",
];

// FREE training hours that count toward the 120 (and most centers require these anyway)
export const FREE_TRAININGS = [
  { name: "Texas A&M AgriLife — Free Annual Training", url: "https://childcare.tamu.edu/courses/texas-annual-training/", hours: "Up to 24 hrs", free: true, area: "Multiple CDA subject areas" },
  { name: "Texas Agriculture / Nutrition & Healthy Meals", url: "https://childcare.tamu.edu/", hours: "1-2 hrs", free: true, area: "Safe & healthy environment" },
  { name: "Food Handler Training (free options)", url: "https://www.dshs.texas.gov/food-handlers", hours: "2 hrs", free: true, area: "Safe & healthy environment" },
  { name: "Shaken Baby Syndrome / Abusive Head Trauma", url: "https://childcare.tamu.edu/", hours: "1 hr", free: true, area: "Child growth & development" },
  { name: "Safe Sleep & SIDS Prevention", url: "https://childcare.tamu.edu/", hours: "1 hr", free: true, area: "Safe & healthy environment" },
  { name: "Emergency Preparedness & Evacuation", url: "https://childcare.tamu.edu/", hours: "1 hr", free: true, area: "Program management" },
  { name: "CPR & First Aid (find a local class)", url: "https://www.redcross.org/take-a-class/cpr", hours: "Varies", free: false, area: "Safe & healthy environment" },
  { name: "Your Local Library — free online courses", url: "https://www.gale.com/databases/gale-presents-udemy", hours: "Varies", free: true, area: "Many CDA subject areas (use your library card)" },
  { name: "Universal Class (via many public libraries)", url: "https://www.universalclass.com/", hours: "Varies", free: true, area: "Child development, guidance, families & more" },
  { name: "Texas HHS Child Care Regulation Training", url: "https://www.hhs.texas.gov/providers/protective-services-providers/child-care-regulation", hours: "Varies", free: true, area: "Professionalism & program operation" },
];

// PD Specialists (Verification Visit observers)
export const PD_SPECIALISTS = [
  { name: "Rachel Garibay", number: "P000044296", region: "San Antonio & nearby counties, TX" },
];

export const APPLICATION_STEPS = [
  "Create your free YourCouncil account at cdacouncil.org.",
  "Choose your CDA setting (Preschool, Infant-Toddler, Family Child Care, or Home Visitor).",
  "Enter your education hours (120) and experience hours (480).",
  "Add your center director's email — she will verify your 480 hours of experience.",
  "Select your PD Specialist for the Verification Visit (pick from our San Antonio list).",
  "Pay the $525 assessment fee (online) to submit your application.",
  "Your PD Specialist receives your info and contacts you to schedule the observation at your center.",
];

export const CDA_FEE = "$525";

export const FUNDING_OPTIONS = [
  {
    title: "Start a GoFundMe",
    icon: "heart",
    desc: "Create a GoFundMe linked to your bank account and share it with friends, family, and your social media. Ask your community to help fund your CDA observation — they want to see you succeed!",
    cta: "Start a GoFundMe",
    url: "https://www.gofundme.com/start",
  },
  {
    title: "T.E.A.C.H. Early Childhood® Texas Scholarship",
    icon: "award",
    desc: "Administered by Texas AEYC, T.E.A.C.H. scholarships can help cover CDA assessment and coursework costs for child care and Head Start / Early Head Start teachers. Ask your director or T.E.A.C.H. counselor if your center participates.",
    cta: "Learn about T.E.A.C.H. Texas",
    url: "https://texasaeyc.org/programs/teach/",
  },
];

// CDA Professional Portfolio binder section cover sheets (3-inch, 3-ring binder)
export const BINDER_SECTIONS = [
  { tab: "Cover", title: "CDA Professional Portfolio", subtitle: "Your Name • CDA Setting • Date" },
  { tab: "Statement", title: "Professional Philosophy Statement", subtitle: "Your written statement of your beliefs about working with young children" },
  { tab: "RC I", title: "Resource Collection I", subtitle: "Planning a Safe, Healthy Learning Environment" },
  { tab: "RC II", title: "Resource Collection II", subtitle: "Steps to Advance Children's Physical & Intellectual Development" },
  { tab: "RC III", title: "Resource Collection III", subtitle: "Positive Ways to Support Social & Emotional Development" },
  { tab: "CS I", title: "Competency Statement I", subtitle: "To establish & maintain a safe, healthy learning environment" },
  { tab: "CS II", title: "Competency Statement II", subtitle: "To advance physical & intellectual competence" },
  { tab: "CS III", title: "Competency Statement III", subtitle: "To support social & emotional development & provide guidance" },
  { tab: "CS IV", title: "Competency Statement IV", subtitle: "To establish positive & productive relationships with families" },
  { tab: "CS V", title: "Competency Statement V", subtitle: "To ensure a well-run, purposeful program responsive to participant needs" },
  { tab: "CS VI", title: "Competency Statement VI", subtitle: "To maintain a commitment to professionalism" },
];

export const OBSERVATION_CHECKLIST = [
  { id: "binder_8_areas", label: "All 8 subject areas are answered in my binder — no blanks in any lesson" },
  { id: "transcript", label: "My official transcript (proof of 120 hours) is in the binder" },
  { id: "labeled", label: "Each section is labeled correctly with tabs in a 3-inch, 3-ring binder" },
  { id: "covers", label: "I printed and inserted the section cover sheets" },
  { id: "director_notified", label: "My center director knows the observer will attend the center all day" },
  { id: "family_questionnaires", label: "Family Questionnaires are collected and summarized" },
];

export const JOURNEY_STEPS = [
  { id: "eligibility", title: "Your Path", subtitle: "Tell us where you're starting" },
  { id: "setting", title: "Choose Your CDA Setting", subtitle: "Which credential fits your classroom?" },
  { id: "education", title: "120 Hours of Education", subtitle: "Your formal CDA coursework" },
  { id: "free_training", title: "Free Training Hours", subtitle: "Fill any gaps for free" },
  { id: "workforce", title: "Workforce Readiness", subtitle: "Get job-ready + your Readiness Score" },
  { id: "placement", title: "Find a Center for Your Hours", subtitle: "Get hired & paid while you train" },
  { id: "experience", title: "480 Experience Hours", subtitle: "Hands-on time in your classroom" },
  { id: "apply", title: "Apply on CDA Council", subtitle: "Get your application on file" },
  { id: "funding", title: "Fund Your Observation", subtitle: "Cover the $525 fee" },
  { id: "observation", title: "Get Ready for Observation Day", subtitle: "Your binder & your director" },
  { id: "credential", title: "Upload Your Credential", subtitle: "Celebrate — you did it!" },
  { id: "feedback", title: "Share Your Story", subtitle: "Help the next teacher" },
];

// Workforce Resources — External links/videos for professionalism
export const WORKFORCE_RESOURCES = [
  { name: "Child Care Provider Training - Texas A&M AgriLife", url: "https://childcare.tamu.edu/courses/", type: "resource", desc: "Free and paid training courses for childcare professionals" },
  { name: "NAEYC Professional Development Resources", url: "https://www.naeyc.org/resources/topics/professional-development", type: "resource", desc: "Professional development resources from the national early childhood association" },
  { name: "Head Start ECLKC - Professional Development", url: "https://eclkc.ohs.acf.hhs.gov/professional-development", type: "resource", desc: "Head Start resources on workforce development and career growth" },
  { name: "Texas Rising Star Provider Resources", url: "https://texasrisingstar.org/providers/", type: "resource", desc: "Quality improvement resources for childcare providers" },
  { name: "Texas Workforce Commission - Child Care", url: "https://www.twc.texas.gov/programs/child-care-services", type: "resource", desc: "State workforce resources and support programs for childcare workers" },
];

// Childcare for Teachers' Own Children
export const CHILDCARE_FOR_TEACHERS = {
  intro: "Many CDA candidates face a challenge: finding childcare for their own children while they work. Here are programs and resources that may help:",
  options: [
    { name: "Child Care Services (CCS) — Texas Workforce Solutions", url: "https://www.twc.texas.gov/programs/child-care-services", desc: "Subsidized childcare for working parents who meet income guidelines" },
    { name: "Head Start & Early Head Start", url: "https://www.acf.hhs.gov/ohs/about/head-start", desc: "Free early childhood programs for eligible families" },
    { name: "Texas Rising Star (Quality Childcare Finder)", url: "https://texasrisingstar.org/parents/", desc: "Find quality-rated childcare providers near you" },
    { name: "Pre-K 4 SA (San Antonio)", url: "https://prek4sa.com/", desc: "Free, full-day Pre-K for San Antonio 4-year-olds" },
    { name: "Ask Your Center", tip: true, desc: "Many childcare centers offer staff discounts or free enrollment for employees' children — ask your director!" },
  ],
};

// Payment & Funding Assistance
export const FUNDING_ASSISTANCE = {
  intro: "The CDA credential costs money — coursework, the $525 assessment fee, and sometimes supplies. Here's how other teachers have funded their journey:",
  options: [
    { name: "T.E.A.C.H. Early Childhood® Texas", url: "https://texasaeyc.org/programs/teach/", desc: "Scholarships for CDA coursework and assessment fees — ask your center if they participate", highlight: true },
    { name: "Ask Your Employer", tip: true, desc: "Many centers have professional development budgets that can cover CDA costs. Frame it as an investment in quality." },
    { name: "GoFundMe", url: "https://www.gofundme.com/start", desc: "Create a fundraiser and share with friends, family, and social media — your community wants to see you succeed!" },
    { name: "Workforce Solutions", url: "https://www.twc.texas.gov/", desc: "Local workforce boards sometimes offer training grants for early childhood careers" },
    { name: "Child Care WAGE$ Texas", url: "https://childcarewages.org/state-profiles/texas/", desc: "Salary supplements for credentialed teachers (varies by county)" },
    { name: "Payment Plans", tip: true, desc: "Some CDA programs offer monthly payment plans — ask before enrolling" },
  ],
};

// Landing-page narrative content
export const CDA_CHALLENGES = [
  "Finding a center willing to hire a new CDA candidate",
  "Completing the required 480 hours of professional experience",
  "Paying for fingerprinting and background checks",
  "Transportation and childcare for your own family",
  "Understanding the CDA process and requirements",
  "Finding mentors and professional support",
];

export const CARE_COMPLY_PROVIDES = [
  "CDA career coaching",
  "Help finding a center for your 480 hours",
  "Workforce development resources",
  "CDA guidance & professional development",
  "Licensing & compliance resources",
  "Community resource referrals",
  "Support completing your 480 hours",
  "A pipeline of qualified staff for childcare centers",
];
